import { useQuery } from '@tanstack/react-query';
import { isToday, parseISO } from 'date-fns';
import { TabBar, type TabBarItem } from '@/shared/ui/TabBar';
import { getMeeting } from '@/shared/api/meetings';

interface MeetingTabsProps {
  meetingId: string;
}

// 모임 하위 화면 단일 탭바 — 요약/투표/코스/대화/정산.
// 이전의 2층 구조(진행·대화·정산 + 요약·투표·코스·LIVE)를 한 층으로 통합.
// LIVE는 모임 당일에만 의미가 있어 그때만 탭으로 노출한다.
export function MeetingTabs({ meetingId }: MeetingTabsProps) {
  const base = `/meetings/${meetingId}`;
  const meetingQ = useQuery({
    queryKey: ['meeting', meetingId],
    queryFn: () => getMeeting(meetingId),
    enabled: !!meetingId,
    staleTime: 30_000,
  });
  const m = meetingQ.data;
  const isLiveDay =
    (m?.status === 'CONFIRMED' || m?.status === 'ONGOING') &&
    Boolean(m?.confirmedDate) &&
    isToday(parseISO(m!.confirmedDate as string));

  const items: TabBarItem[] = [
    { to: base, end: true, label: '요약' },
    { to: `${base}/vote`, label: '투표' },
    {
      to: `${base}/places`,
      label: '코스',
      activeWhen: (pathname) =>
        pathname.startsWith(`${base}/places`) ||
        pathname.startsWith(`${base}/schedule`) ||
        pathname.startsWith(`${base}/point`),
    },
    { to: `${base}/chat`, label: '대화' },
    {
      to: `${base}/expense`,
      label: '정산',
      activeWhen: (pathname) =>
        pathname.startsWith(`${base}/expense`) || pathname.startsWith(`${base}/settlement`),
    },
    ...(isLiveDay ? [{ to: `${base}/live`, label: 'LIVE' } satisfies TabBarItem] : []),
  ];

  return <TabBar ariaLabel="모임 탭" items={items} />;
}
